import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from '@layout/AppShell';
import { AdminShell } from '@layout/AdminShell';
import { AdminGuard } from '@layout/AdminGuard';
import { PageSpinner } from '@ui/PageSpinner';

// Public pages
const HomePage = lazy(() => import('./pages/HomePage'));
const VehiclesPage = lazy(() => import('./pages/VehiclesPage'));
const VehicleDetailPage = lazy(() => import('./pages/VehicleDetailPage'));
const VehicleExplorePage = lazy(() => import('./pages/VehicleExplorePage'));
const SectionDetailPage = lazy(() => import('./pages/SectionDetailPage'));
const LearnHubPage = lazy(() => import('./pages/LearnHubPage'));
const FlashcardsPage = lazy(() => import('./pages/FlashcardsPage'));
const QuizPage = lazy(() => import('./pages/QuizPage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const ImpressumPage = lazy(() => import('./pages/ImpressumPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Admin
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminVehicles = lazy(() => import('./pages/admin/AdminVehicles'));
const AdminVehicleEditor = lazy(() => import('./pages/admin/AdminVehicleEditor'));
const AdminLearning = lazy(() => import('./pages/admin/AdminLearning'));
const AdminMedia = lazy(() => import('./pages/admin/AdminMedia'));
const AdminAudit = lazy(() => import('./pages/admin/AdminAudit'));

export default function App() {
  return (
    <Suspense fallback={<PageSpinner />}>
      <Routes>
        {/* Public */}
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/fahrzeuge" element={<VehiclesPage />} />
          <Route path="/fahrzeuge/:slug" element={<VehicleDetailPage />} />
          <Route path="/fahrzeuge/:slug/erkunden" element={<VehicleExplorePage />} />
          <Route path="/fahrzeuge/:slug/sektion/:sectionSlug" element={<SectionDetailPage />} />
          <Route path="/lernen" element={<LearnHubPage />} />
          <Route path="/lernen/karteikarten" element={<FlashcardsPage />} />
          <Route path="/lernen/quiz" element={<QuizPage />} />
          <Route path="/suche" element={<SearchPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Admin login (kein Shell, eigenes Layout) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Admin Backoffice */}
        <Route element={<AdminGuard />}>
          <Route element={<AdminShell />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/fahrzeuge" element={<AdminVehicles />} />
            <Route path="/admin/fahrzeuge/:id" element={<AdminVehicleEditor />} />
            <Route path="/admin/lernen" element={<AdminLearning />} />
            <Route path="/admin/medien" element={<AdminMedia />} />
            <Route path="/admin/audit" element={<AdminAudit />} />
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
